import { Lang, User } from "../User";

export class MockUser implements User {
  private static INDEX = 0;

  public newsletter = false;
  public betaStatus: "active" | "inactive" = "inactive";
  public email = "foo@blacknut.com";
  public firstName = "foo";
  public id: string;
  public lang = Lang.ENGLISH;
  public lastName = "bar";
  public birthDate?: string | undefined;
  public status = "active";
  public powerUser = false;
  public autoPassword = false;
  public anonymous = false;
  public uuid: string;
  public autoEmail = false;
  public passwordLastUpdatedDate = "0001-01-01T00:00:00Z";
  public supportEmail = "foo@blacknut.com";

  constructor() {
    MockUser.INDEX++;
    this.id = `id-${MockUser.INDEX}`;
    this.uuid = `uuid-${MockUser.INDEX}`;
  }
}
